var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPir(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.99479 9.99984C12.296 9.99984 14.1615 8.13436 14.1615 5.83317C14.1615 3.53198 12.296 1.6665 9.99479 1.6665C7.6936 1.6665 5.82812 3.53198 5.82812 5.83317C5.82812 8.13436 7.6936 9.99984 9.99479 9.99984Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99687 12.0835C5.82187 12.0835 2.42188 14.8835 2.42188 18.3335C2.42188 18.5668 2.60521 18.7502 2.83854 18.7502H17.1552C17.3885 18.7502 17.5719 18.5668 17.5719 18.3335C17.5719 14.8835 14.1719 12.0835 9.99687 12.0835Z",
    fill: "#292D32"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPir);
export default __webpack_public_path__ + "static/media/pir.5a174b07d7b214dd77fcfdff9a046bcd.svg";
export { ForwardRef as ReactComponent };